<template>
  <ion-card
    @click="router.push({ name: 'InvoiceDetail', params: { invoiceId: id } })"
    color="light"
    class="no-shadow spacing-xs filter-card ion-no-margin py-xs invoice-card results-card"
  >
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex align-center">
        <div :class="getClass()">
          <ion-icon :icon="getIcon()" :color="getColor()" class="info-icon"></ion-icon>
        </div>

        <div class="px-xs">
          <p class="font-sm hide">{{ code }}</p>
          <p v-if="paidAt" class="font-xxs grey hide">
            {{ t('invoices.paidOn') }}
            {{ formatDateTime(paidAt, locale, true, true) }}
          </p>
        </div>
      </div>

      <div class="d-flex align-center gap-sm">
        <p class="font-md bold-medium">{{ amountMask(grandTotal, currency) }}</p>
        <ion-icon :icon="chevronForwardOutline" class="info-icon"></ion-icon>
      </div>
    </div>
  </ion-card>
</template>

<script setup lang="ts">
  import router from '@/router';
  import { formatDateTime } from '@/utils/date-utils';
  import { amountMask } from '@/utils/validations/formats';
  import { IonCard, IonIcon } from '@ionic/vue';
  import { alertCircle, checkmarkCircle, chevronForwardOutline } from 'ionicons/icons';
  import { useI18n } from 'vue-i18n';

  const props = withDefaults(
    defineProps<{
      code: string;
      paidAt?: string;
      grandTotal: number;
      currency: string;
      status: string;
      id?: string;
    }>(),
    {},
  );

  const { t, locale } = useI18n();

  const getIcon = () => {
    switch (props.status) {
      case 'pending':
        return alertCircle;
      case 'sent':
        return alertCircle;
      case 'paid':
        return checkmarkCircle;
      default:
        return undefined;
    }
  };

  const getClass = () => {
    switch (props.status) {
      case 'pending':
        return 'pending-btn';
      case 'sent':
        return 'pending-btn';
      case 'paid':
        return 'success-btn';
      default:
        return undefined;
    }
  };

  const getColor = () => {
    switch (props.status) {
      case 'pending':
        return 'orange';
      case 'sent':
        return 'orange';
      case 'paid':
        return 'success';
      default:
        return undefined;
    }
  };
</script>

<style lang="css" scoped>
  .hide {
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .invoice-card {
    border-radius: 0px;
    margin-left: -15px;
    margin-right: -15px;
  }
</style>
